import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

const container = document.getElementById("root");

if (container) {
  // Always client-render: prerendered HTML is for crawlers only. hydrateRoot
  // fails when lazy routes, API data, or localStorage differ from the snapshot.
  createRoot(container).render(<App />);
}
